import { slotLoop } from "./slotLoop.js";
import { makePresentation } from "./makePresentation.js";
import { PaylinesContainer } from "../components/PaylinesContainer.js";
import { slotDefinition } from "../configs/slotDefinition.config.js";

export async function slotInit(scope, ctx) {
    const { scenes, gameLogic, audio, data } = ctx;

    const hud = await scenes.show("HUDScene");

    ctx.hud = hud;
    ctx.reels = scenes.get("ReelsScene");

    const reelsOptions = ctx.reels.reels.options;
    const lastCol = reelsOptions.columns.at(-1);
    const fieldWidth = lastCol.x + (lastCol.width ?? reelsOptions.symbolWidth);
    const fieldHeight = reelsOptions.rows * reelsOptions.symbolHeight;
    ctx.paylinesContainer = new PaylinesContainer({
        paylines: slotDefinition.paylines,
        colors: slotDefinition.paylineColors,
        columns: reelsOptions.columns,
        symbolWidth: reelsOptions.symbolWidth,
        symbolHeight: reelsOptions.symbolHeight,
        fieldWidth,
        clip: { x: 0, y: 0, width: fieldWidth, height: fieldHeight },
    });
    ctx.reels.find("winLinesContainer").addChild(ctx.paylinesContainer);

    audio.setAllVolume(data.volume);
    // TODO: audio.playMusic("1.0_part_1", { loop: false });

    ctx.makePresentation = (result, options = {}) => makePresentation(ctx, result, options);

    return slotLoop;
}
